import { apiClient } from 'api'

export type Credentials = {
    email: string
    password: string
    serviceToken: string
}

const ACCESS_TOKEN_KEY = 'access_token'

export function getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY)
}

function setAccessToken(token: string) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token)
}

function removeAccessToken() {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
}

export async function checkAuthorizationStatus() {
    try {
        const token = getAccessToken()

        if (!token) {
            return false
        }

        const user = await apiClient.get('/profile')
        return !!user
    } catch (e) {
        console.error(e)

        return false
    }
}

export async function signIn(credentials: Credentials, callback: () => void, errorCallback: () => void) {
    try {
        const { access_token } = await apiClient.post<
            Credentials,
            {
                access_token: string
            }
        >('/auth/login', {
            ...credentials,
            serviceToken: process.env.REACT_APP_SERVICE_JWT ?? '',
        })

        setAccessToken(access_token)

        apiClient.setAccessToken(access_token)

        callback()
    } catch (e) {
        console.error(e)

        errorCallback()
    }
}

export function signOut(callback: () => void) {
    removeAccessToken()
    apiClient.removeAccessToken()

    callback()
}
